import { render, staticRenderFns } from "./ShogiPlayerWc.vue?vue&type=template&id=67eaded6&lang=pug&shadow"
import script from "./ShogiPlayerWc.vue?vue&type=script&lang=js&shadow"
export * from "./ShogiPlayerWc.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./ShogiPlayerWc.vue?vue&type=style&index=0&id=67eaded6&prod&lang=sass&shadow")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./ShogiPlayerWc.vue?vue&type=style&index=1&id=67eaded6&prod&lang=css&shadow")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@6.8.1_webpack@5.86.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports